export default "__VITE_ASSET__Cru5m_dT__"